import CamposParametrosFiscais, { CampoParametro } from "pages/fiscal/parametrosFiscais/CamposParametrosFiscais";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import TransacaoNotaFiscal from "model/fiscal/TransacaoNotaFiscal";
import Transacao from "model/suprimentos/Transacao";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import TransacaoNotaFiscalService from "service/fiscal/TransacaoNotaFiscalService";
import TransacaoService from "service/suprimentos/TransacaoService";
import Cfop from "model/fiscal/Cfop";
import CfopService from "service/fiscal/CfopService";

const transacaoNotaFiscalService = new TransacaoNotaFiscalService();
const transacaoService = new TransacaoService();
const cfopService = new CfopService();

const camposIcms: CampoParametro<TransacaoNotaFiscal>[] = [
    {
        "chave": "idSituacaoTributariaPadrao",
        "label": "Situação Tributária padrão",
        "tipo": "referencia",
        "referencia": "situacaoTributaria"
    },
    {
        "chave": "tributaIcms",
        "label": "Tributa ICMS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiFreteBaseIcms",
        "label": "Inclui frete na base de cálculo do ICMS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiSeguroBaseIcms",
        "label": "Inclui seguro na base de cálculo do ICMS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiOutrasDespesasBaseIcms",
        "label": "Inclui outras despesas na base de cálculo do ICMS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiIpiBaseIcms",
        "label": "Inclui IPI na base de cálculo do ICMS",
        "tipo": "boolean"
    }
];

const camposIpi: CampoParametro<TransacaoNotaFiscal>[] = [
    {
        "chave": "tributaIpi",
        "label": "Tributa IPI",
        "tipo": "boolean"
    },
    {
        "chave": "incluiFreteBaseIpi",
        "label": "Inclui frete na base de cálculo do IPI",
        "tipo": "boolean"
    },
    {
        "chave": "incluiSeguroBaseIpi",
        "label": "Inclui seguro na base de cálculo do IPI",
        "tipo": "boolean"
    },
    {
        "chave": "incluiOutrasDespesasBaseIpi",
        "label": "Inclui outras despesas na base de cálculo do IPI",
        "tipo": "boolean"
    }
];

const camposPis: CampoParametro<TransacaoNotaFiscal>[] = [
    {
        "chave": "tributaPis",
        "label": "Tributa PIS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiFreteBasePis",
        "label": "Inclui frete na base de cálculo do PIS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiSeguroBasePis",
        "label": "Inclui seguro na base de cálculo do PIS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiOutrasDespesasBasePis",
        "label": "Inclui outras despesas na base de cálculo do PIS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiIpiBasePis",
        "label": "Inclui IPI na base de cálculo do PIS",
        "tipo": "boolean"
    },
    {
        "chave": "excluiIcmsBasePis",
        "label": "Exclui ICMS da base de cálculo do PIS",
        "tipo": "boolean"
    }
];

const camposCofins: CampoParametro<TransacaoNotaFiscal>[] = [
    {
        "chave": "tributaCofins",
        "label": "Tributa COFINS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiFreteBaseCofins",
        "label": "Inclui frete na base de cálculo do COFINS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiSeguroBaseCofins",
        "label": "Inclui seguro na base de cálculo do COFINS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiOutrasDespesasBaseCofins",
        "label": "Inclui outras despesas na base de cálculo do COFINS",
        "tipo": "boolean"
    },
    {
        "chave": "incluiIpiBaseCofins",
        "label": "Inclui IPI na base de cálculo do COFINS",
        "tipo": "boolean"
    },
    {
        "chave": "excluiIcmsBaseCofins",
        "label": "Exclui ICMS da base de cálculo do COFINS",
        "tipo": "boolean"
    }
];

export default function TransacaoNotaFiscalCadastro() {
    const [transacaoNotaFiscal, setTransacaoNotaFiscal] = useState(new TransacaoNotaFiscal());
    const [transacoesEstoque, setTransacoesEstoque] = useState<Transacao[]>([]);
    const [erro, setErro] = useState("");
    const [cfops, setCfops] = useState<Cfop[]>([]);
    const [carregandoCfops, setCarregandoCfops] = useState(false);
    const [abaAtiva, setAbaAtiva] = useState(0);

    useEffect(() => {
        let ativo = true;
        setCarregandoCfops(true);
        setCfops([]);
        cfopService.listar(transacaoNotaFiscal.tipoOperacao, transacaoNotaFiscal.destinoOperacao)
            .then(dados => { if (ativo) setCfops(dados); })
            .catch(() => { if (ativo) setErro("Não foi possível carregar o catálogo de CFOPs."); })
            .finally(() => { if (ativo) setCarregandoCfops(false); });
        return () => { ativo = false; };
    }, [transacaoNotaFiscal.tipoOperacao, transacaoNotaFiscal.destinoOperacao]);

    function alterarOperacao(campos: Partial<Pick<TransacaoNotaFiscal, "tipoOperacao" | "destinoOperacao">>) {
        setTransacaoNotaFiscal(anterior => {
            const proxima = { ...anterior, ...campos };
            return {
                ...proxima, cfopPadrao: cfopService.compativel(proxima.cfopPadrao, proxima.tipoOperacao,
                    proxima.destinoOperacao) ? proxima.cfopPadrao : null
            };
        });
    }

    useEffect(() => {
        transacaoService.getAll()
            .then(setTransacoesEstoque)
            .catch(error => console.error("Erro ao buscar transações de estoque:", error));
    }, []);

    function validar() {
        if (!transacaoNotaFiscal.codigoInterno || !transacaoNotaFiscal.descricao ||
            !transacaoNotaFiscal.naturezaOperacao || !transacaoNotaFiscal.finalidadeNfe ||
            !transacaoNotaFiscal.tipoOperacao) {
            setErro("Preencha código, descrição, natureza, finalidade e tipo de operação.");
            return false;
        }
        if (transacaoNotaFiscal.cstIcmsPadrao && transacaoNotaFiscal.csosnPadrao) {
            setErro("Informe CST ICMS ou CSOSN, não ambos.");
            return false;
        }
        if (transacaoNotaFiscal.cfopPadrao && (carregandoCfops
            || !cfops.some(cfop => cfop.codigo === transacaoNotaFiscal.cfopPadrao))) {
            setErro("Selecione um CFOP do catálogo compatível com a operação.");
            return false;
        }
        const gruposTributarios = [camposIcms, camposIpi, camposPis, camposCofins];
        for (let indice = 0; indice < gruposTributarios.length; indice++) {
            const pendente = gruposTributarios[indice].find(campo => campo.tipo === "boolean"
                && typeof transacaoNotaFiscal[campo.chave] !== "boolean");
            if (pendente) {
                setErro(`Informe Sim ou Não em "${pendente.label}".`);
                setAbaAtiva(indice + 1);
                return false;
            }
        }
        setErro("");
        return true;
    }

    return (
        <BaseCadastro model={transacaoNotaFiscal} service={transacaoNotaFiscalService}
            setModel={(value: TransacaoNotaFiscal) => setTransacaoNotaFiscal(value)}
            getNewModel={() => new TransacaoNotaFiscal()} novoCadastro
            validar={validar} pathCadastro="/transacaoNotaFiscal" urlService="/transacaoNotaFiscal"
            tituloPagina="Transação de nota fiscal">
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">Transação de nota fiscal</label>
            </div>
            <TabView renderActiveOnly={false} activeIndex={abaAtiva} onTabChange={e => setAbaAtiva(e.index)}>
                <TabPanel header="Dados Gerais">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <Checkbox inputId="transacao-ativa" checked={transacaoNotaFiscal.ativa}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, ativa: !!e.checked })} />
                            <Label htmlFor="transacao-ativa" className="ms-2">Ativa</Label>
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Checkbox inputId="transacao-estoque" checked={transacaoNotaFiscal.movimentaEstoque}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, movimentaEstoque: !!e.checked })} />
                            <Label htmlFor="transacao-estoque" className="ms-2">Movimenta estoque</Label>
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2" obrigatorio>Código</Label>
                            <InputText value={transacaoNotaFiscal.codigoInterno} maxLength={10}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, codigoInterno: e.target.value })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2" obrigatorio>Descrição</Label>
                            <InputText value={transacaoNotaFiscal.descricao} maxLength={100}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, descricao: e.target.value })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2" obrigatorio>Natureza da operação</Label>
                            <InputText value={transacaoNotaFiscal.naturezaOperacao} maxLength={60}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, naturezaOperacao: e.target.value })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2" obrigatorio>Finalidade</Label>
                            <Dropdown value={transacaoNotaFiscal.finalidadeNfe} options={transacaoNotaFiscalService.getListaFinalidadeNfe()}
                                optionLabel="label" optionValue="value"
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, finalidadeNfe: e.value })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2" htmlFor="transacao-destino">Destino da operação</Label>
                            <Dropdown inputId="transacao-destino" value={transacaoNotaFiscal.destinoOperacao} options={transacaoNotaFiscalService.getListaDestinoOperacao()}
                                optionLabel="label" optionValue="value" showClear
                                onChange={(e) => alterarOperacao({ destinoOperacao: e.value })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2" obrigatorio htmlFor="transacao-tipo">Tipo de operação</Label>
                            <Dropdown inputId="transacao-tipo" value={transacaoNotaFiscal.tipoOperacao} options={transacaoNotaFiscalService.getListaTipoOperacao()}
                                optionLabel="label" optionValue="value"
                                onChange={(e) => alterarOperacao({ tipoOperacao: e.value })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Transação de estoque</Label>
                            <Dropdown value={transacaoNotaFiscal.transacaoEstoque?.codigo ?? null} options={transacoesEstoque}
                                optionLabel="descricao" optionValue="codigo" showClear filter
                                onChange={(e) => setTransacaoNotaFiscal({
                                    ...transacaoNotaFiscal,
                                    transacaoEstoque: transacoesEstoque.find(item => item.codigo === e.value) ?? null
                                })} style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">CFOP padrão</Label>
                            <Dropdown aria-label="CFOP padrão" value={transacaoNotaFiscal.cfopPadrao}
                                options={cfops.map(cfop => ({ ...cfop, label: `${cfop.codigo} - ${cfop.descricao}` }))}
                                optionLabel="label" optionValue="codigo" filter filterBy="codigo,descricao" showClear
                                disabled={carregandoCfops}
                                placeholder="Selecione o CFOP" emptyMessage="Nenhum CFOP para esta operação"
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, cfopPadrao: e.value ?? null })}
                                style={{ width: "100%" }} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="ICMS">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">CST ICMS padrão</Label>
                            <InputText value={transacaoNotaFiscal.cstIcmsPadrao ?? ""} maxLength={2}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, cstIcmsPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">CSOSN padrão</Label>
                            <InputText value={transacaoNotaFiscal.csosnPadrao ?? ""} maxLength={3}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, csosnPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Percentual da alíquota padrão de ICMS (%)</Label>
                            <InputNumber value={transacaoNotaFiscal.aliquotaIcmsPadrao} minFractionDigits={0} maxFractionDigits={4}
                                onValueChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, aliquotaIcmsPadrao: e.value ?? null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Alíquota de ICMS na UF de destino (%)</Label>
                            <InputNumber value={transacaoNotaFiscal.aliquotaIcmsUfDestinoPadrao} minFractionDigits={0} maxFractionDigits={4}
                                onValueChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, aliquotaIcmsUfDestinoPadrao: e.value ?? null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Alíquota de FCP na UF de destino (%)</Label>
                            <InputNumber value={transacaoNotaFiscal.aliquotaFcpUfDestinoPadrao} minFractionDigits={0} maxFractionDigits={4}
                                onValueChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, aliquotaFcpUfDestinoPadrao: e.value ?? null })}
                                style={{ width: "100%" }} />
                        </div>

                        <CamposParametrosFiscais dados={transacaoNotaFiscal} campos={camposIcms} booleanosObrigatorios vertical larguraCampo="100%"
                            onChange={campos => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, ...campos })} />
                    </div>
                </TabPanel>
                <TabPanel header="IPI">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">CST IPI padrão</Label>
                            <InputText value={transacaoNotaFiscal.cstIpiPadrao ?? ""} maxLength={2}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, cstIpiPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Código de enquadramento IPI padrão</Label>
                            <InputText value={transacaoNotaFiscal.codigoEnquadramentoIpiPadrao ?? ""} maxLength={3}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, codigoEnquadramentoIpiPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                        <CamposParametrosFiscais dados={transacaoNotaFiscal} campos={camposIpi} booleanosObrigatorios vertical larguraCampo="100%"
                            onChange={campos => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, ...campos })} />
                    </div>

                </TabPanel>
                <TabPanel header="PIS">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">CST PIS padrão</Label>
                            <InputText value={transacaoNotaFiscal.cstPisPadrao ?? ""} maxLength={2}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, cstPisPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Percentual da alíquota padrão de PIS (%)</Label>
                            <InputNumber value={transacaoNotaFiscal.aliquotaPisPadrao} minFractionDigits={0} maxFractionDigits={4}
                                onValueChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, aliquotaPisPadrao: e.value ?? null })}
                                style={{ width: "100%" }} />
                        </div>

                        <CamposParametrosFiscais dados={transacaoNotaFiscal} campos={camposPis} booleanosObrigatorios vertical larguraCampo="100%"
                            onChange={campos => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, ...campos })} />
                    </div>
                </TabPanel>
                <TabPanel header="COFINS">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">CST COFINS padrão</Label>
                            <InputText value={transacaoNotaFiscal.cstCofinsPadrao ?? ""} maxLength={2}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, cstCofinsPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Percentual da alíquota padrão de COFINS (%)</Label>
                            <InputNumber value={transacaoNotaFiscal.aliquotaCofinsPadrao} minFractionDigits={0} maxFractionDigits={4}
                                onValueChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, aliquotaCofinsPadrao: e.value ?? null })}
                                style={{ width: "100%" }} />
                        </div>
                        <CamposParametrosFiscais dados={transacaoNotaFiscal} campos={camposCofins} booleanosObrigatorios vertical larguraCampo="100%"
                            onChange={campos => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, ...campos })} />
                    </div>
                </TabPanel>
                <TabPanel header="IBS/CBS">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">CST IBS/CBS padrão</Label>
                            <InputText value={transacaoNotaFiscal.cstIbsCbsPadrao ?? ""} maxLength={3}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, cstIbsCbsPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-sm-12 mb-3">
                            <Label className="d-block mb-2">Classificação tributária padrão</Label>
                            <InputText value={transacaoNotaFiscal.classificacaoTributariaPadrao ?? ""} maxLength={6}
                                onChange={(e) => setTransacaoNotaFiscal({ ...transacaoNotaFiscal, classificacaoTributariaPadrao: e.target.value || null })}
                                style={{ width: "100%" }} />
                        </div>
                    </div>
                </TabPanel>
            </TabView>
            {erro && <small className="p-error">{erro}</small>}
        </BaseCadastro>
    );
}
